import { Cachable } from "./cachable"

export interface Record extends Cachable {
    id: string;
}

export enum RecordLifecycleState {
    IN_PROGRESS = 'inProgress',
    TO_VALIDATED = 'toValidated',
    VALIDATED = 'validated'
}